module.exports = "/images/fef2e1278ffa301854eaa0876e6f0983.svg";